import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { dismissHomeInsight, getHomeInsights } from '../api/home-insights'

const KEY = ['home', 'insights'] as const

export function useHomeInsights() {
  return useQuery({
    queryKey: KEY,
    queryFn: getHomeInsights,
    staleTime: 60_000,
  })
}

export function useDismissInsight() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: dismissHomeInsight,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}
